import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./fr.json";
import en from "./en.json";

i18n
  // Plugin: detects the user's preferred language on load
  // (checks localStorage first, then the browser's settings)
  .use(LanguageDetector)

  // Plugin: connects i18next to React so components can
  // subscribe to language changes via useTranslation()
  .use(initReactI18next)

  // Starts the i18next engine with this config
  .init({
    // The dictionaries i18next can switch between
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },

    // If the active language is missing a key, fall back to French
    fallbackLng: "fr",

    // Only these languages are allowed — prevents i18next from
    // trying to load an unexpected language code from the browser
    supportedLngs: ["fr", "en"],

    interpolation: {
      // Don't HTML-escape interpolated values (e.g. t("hi", {name}))
      // React already escapes everything when rendering, so this
      // avoids double-escaping
      escapeValue: false,
    },

    detection: {
      // Order to check for a saved/preferred language:
      // 1. localStorage (returning user), 2. browser settings (new user)
      order: ["localStorage", "navigator"],

      // Where to persist the language once it's chosen/changed
      caches: ["localStorage"],

      // The localStorage key name used to store it
      lookupLocalStorage: "app_language",
    },
  });

// Export the configured instance so other files (rarely needed directly —
// useTranslation() gives you access to it in components)
export default i18n;